import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'zop-button-field',
    imports: [
        MatIconModule
    ],
    template: `
    <div>
      <button matButton [type]="props['type']" (click)="onClick($event)">
        <mat-icon [svgIcon]="'mat_solid:delete'" class="text-red-500 mt-4"></mat-icon>
      </button>
    </div>
  `
})
export class ZopButtonField extends FieldType {
  onClick($event: Event) {
    if (this.props['onClick']) {
      this.props['onClick']($event);
    }
  }
}